module.exports = __webpack_public_path__ + "fonts/nunito-sans-bold.51066f4d.ttf";